<template>
  <md-card-content>
    <!-- その他 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>その他</label>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field :class="getValidationClass('contract.reason')">
          <label>申し込みのきっかけ</label>
          <md-select :disabled="!activated || sending" required v-model="form.contract.reason" required>
            <md-option v-for="(reason,index) in contractReason" :value="reason" :key="'reason-' + index">
              {{ reason }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import Common            from "../../modules/common";
import CommonMixin       from "../../mixins/commonMixin";
import {validationMixin} from "vuelidate";
import ContractFormMixin from "../../mixins/contractFormMixin";

export default {
  name  : 'ContractFormEtc',
  props : ['value', 'activated'],
  mixins: [CommonMixin, ContractFormMixin, validationMixin],
  data  : () => ({
    contractReason: Common.contractReason,
    form          : {
      contract: {
        reason: Common.contractReason[0],
      },
    },
  }),
  validations() {
    return {
      form: {
        contract: {
          reason: {},
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
